// src/contexts/ProjectModalContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog } from '@mui/material';
import ProjectCard from '../components/cards/ProjectCard';

const ProjectModalContext = createContext(null);

export const useProjectModal = () => {
  const ctx = useContext(ProjectModalContext);
  if (!ctx) return { openProjectModal: () => {} };
  return ctx;
};

export const ProjectModalProvider = ({ children, onAddToLayout }) => {
  const [state, setState] = useState({ open: false, project: null });

  const openProjectModal = useCallback((project) => {
    setState({ open: true, project });
  }, []);

  const closeProjectModal = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  const handleAddToLayout = useCallback(() => {
    closeProjectModal();
    if (onAddToLayout && state.project) onAddToLayout(state.project);
  }, [state.project, onAddToLayout, closeProjectModal]);

  return (
    <ProjectModalContext.Provider value={{ openProjectModal }}>
      {children}
      <Dialog
        open={state.open}
        onClose={closeProjectModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible' } }}
      >
        {state.project && (
          <ProjectCard
            project={state.project}
            id={`modal_project_${state.project.project_id || state.project.name}`}
            onClose={closeProjectModal}
            disableDragging
            onAddToLayout={onAddToLayout ? handleAddToLayout : undefined}
          />
        )}
      </Dialog>
    </ProjectModalContext.Provider>
  );
};
